import React from 'react'
import CookieBanner from 'react-cookie-banner';
import CookiesLink from '../Linking/cookiesLink'
 
//https://github.com/buildo/react-cookie-banner/blob/master/src/README.md
const CookiesNotification = () => (
<CookieBanner
buttonMessage={"Entendido"}
disableStyle={true}
dismissOnScroll={false}
message="Utilizamos cookies para asegurar que damos la mejor experiencia al usuario en nuestro sitio web. "
link={<CookiesLink/>}
onAccept={() => {}}
cookie="user-has-accepted-cookies" />
)

export default CookiesNotification


// WEBPACK FOOTER //
// ./src/components/Notifications/cookiesNotification.js